import React from "react";
import { CATEGORY_COLORS, formatBRL, formatDate } from "../lib/constants";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";

export default function TransactionRow({ tx, onClick }) {
  const income = tx.type === "income";
  const color = CATEGORY_COLORS[tx.category] || "#94A3B8";
  return (
    <button
      data-testid={`tx-row-${tx.id}`}
      onClick={() => onClick(tx)}
      className="w-full text-left flex items-center gap-3 p-3 rounded-2xl hover:bg-slate-800/40 active:scale-[0.99] transition-colors"
    >
      <div
        className="w-11 h-11 shrink-0 rounded-2xl flex items-center justify-center"
        style={{
          backgroundColor: color + "22",
          color,
          boxShadow: `0 4px 12px -6px ${color}55`,
        }}
      >
        {income ? <ArrowUpRight className="w-5 h-5" strokeWidth={2.4} /> : <ArrowDownRight className="w-5 h-5" strokeWidth={2.4} />}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-white truncate">{tx.description}</p>
        <p className="text-xs text-slate-400 truncate flex items-center gap-1.5 mt-0.5">
          <span
            className="px-1.5 py-0.5 rounded-md text-[10px] font-semibold"
            style={{ backgroundColor: color + "22", color }}
          >{tx.category}</span>
          <span className="text-slate-600">•</span>
          <span>{formatDate(tx.date)}</span>
        </p>
      </div>
      <div className={`text-right font-mono-nums font-bold text-sm shrink-0 ${income ? "text-emerald-300" : "text-rose-300"}`}>
        {income ? "+" : "−"} {formatBRL(tx.amount)}
      </div>
    </button>
  );
}
